export const TBL_HEADERS = [
  {
    name: "",
    variable: "",
  },
  {
    name: "Record Id",
    variable: "",
  },
  {
    name: "Collection Date",
    variable: "",
  },
  {
    name: "Recieved Date",
    variable: "",
  },
  {
    name: "Previous Status",
    variable: "",
  },
  {
    name: "Action",
    variable: "",
  },
  {
    name: "New Status",
    variable: "",
  },
  {
    name: "Uploaded File",
    variable: "",
  },
  {
    name: "First Name",
    variable: "",
  },
  {
    name: "Last Name",
    variable: "",
  },
  {
    name: "Phone Number",
    variable: "",
  },
  {
    name: "Physician Name",
    variable: "",
  },
  {
    name: "Facility Name",
    variable: "",
  },
  {
    name: "Requisition Type",
    variable: "",
  },
  {
    name: "Added By",
    variable: "",
  },
  {
    name: "Updated By",
    variable: "",
  },
  {
    name: "Updated Date & Time",
    variable: "",
  },
  {
    name: "Time on Status",
    variable: "",
  },
];
